export default "__VITE_ASSET__9zOUl9CK__"